<template>
    <div>
        <Head title="Місце для рибалки"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('points.index')"
            >
                Місце для рибалки
            </Link>
            <span class="text-indigo-400 font-medium">/</span> Створити
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full"
                                label="Назва"/>
                    <text-input v-model="form.latitude" :error="form.errors.latitude" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Широта"/>
                    <text-input v-model="form.longitude" :error="form.errors.longitude"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Довгота"/>
                    <select-input v-model="form.lake_id" :error="form.errors.lake_id" class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Озеро">
                        <option :value="null"/>
                        <option v-for="lake in lakes" :key="lake.id" :value="lake.id">{{ lake.name }}</option>
                    </select-input>
                    <text-input v-model="form.number" :error="form.errors.number"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Номер"/>
                    <textarea-input v-model="form.short_description" :error="form.errors.short_description"
                                    class="pb-8 pr-6 w-full" label="Короткий опис"/>
                    <div class="pb-8 pr-6 w-full">
                        <label class="form-label" for="description">Опис</label>
                        <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                                  id="description" class="description"/>
                    </div>

                    <drag-and-drop
                        v-model="form.images"
                        :error="form.errors.images"
                        class="pb-8 pr-6 w-full lg:w-1/2"
                        type="file"
                        accept="image/*"
                        label="Зображення"
                    />
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити місце
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import DragAndDrop from "@/Shared/DragAndDrop.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import CKEditor from "@ckeditor/ckeditor5-vue"
import TextareaInput from "@/Shared/TextareaInput.vue";

export default {
    components: {
        TextareaInput,
        DragAndDrop,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        ckeditor: CKEditor.component
    },
    layout: Layout,
    props: {
        lakes: Array,
    },
    remember: 'form',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            form: this.$inertia.form({
                name: '',
                latitude: '',
                longitude: '',
                lake_id: null,
                number: '',
                description: '',
                short_description: '',
                images: '',
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('points.index'))
        },
    },
}
</script>

<style scoped>
:deep(.ck.ck-editor__editable_inline) {
    min-height: 500px;
}
.description {
    width: 100%;
    min-width: 100%;
}
</style>
